import { Component } from '@angular/core';
import { PAYMENT_TYPE_OPTIONS, PaymentTypeOption } from 'src/app/types/constants';

@Component({
  selector: 'app-payment-product-modal',
  templateUrl: './payment-product-modal.component.html',
  styleUrls: ['./payment-product-modal.component.scss'],
  standalone: false
})
export class PaymentProductModalComponent {

  paymentTypes: PaymentTypeOption[] = PAYMENT_TYPE_OPTIONS;

}